import { LAUNCHDARKLY_FLAGS } from 'containers/launch-darkly/launch-darkly-flags';
import { useLaunchDarklyFlag } from 'containers/launch-darkly/launch-darkly-provider.hooks';

export function useIsEligibleToPublishRewardsProgram() {
  const { IS_ELIGIBLE_TO_PUBLISH_REWARDS_PROGRAM } = LAUNCHDARKLY_FLAGS;

  return useLaunchDarklyFlag(IS_ELIGIBLE_TO_PUBLISH_REWARDS_PROGRAM);
}
